import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import styles from '@containers/ErrorPages/ErrorPages.module.css';

import { systemApi } from '@reducers/system';
import { skipToken } from '@reduxjs/toolkit/query';

export const Page503 = () => {
  const { isAvailable } = useSelector((state) => state.system);
  systemApi.useCheckBackendHealthQuery(isAvailable ? skipToken : {});
  useEffect(() => {
    document.title = 'Site Maintenance';
  }, []);
  if (isAvailable) {
    return null;
  }
  return (
    <div className={styles.siteMaintenanceContainer}>
      <div className={styles.siteMaintenanceBody}>
        <span className={styles.siteMaintenanceHeader}>
          We&rsquo;ll be back soon!
        </span>
        <div>
          <p>
            Sorry for the inconvenience but we&rsquo;re performing some
            maintenance at the moment. If you need to you can always{' '}
            <a href="mailto:info@didxl.com">contact us</a>, otherwise
            we&rsquo;ll be back online shortly!
          </p>
          <p>&mdash; The didXL Team</p>
        </div>
      </div>
    </div>
  );
};
